import React, { useContext, useState, useEffect } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

import * as firebase from 'firebase/app';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const LoginPage = (props) => {
    const [password, setPassword] = useState('');
    const [checked, setChecked] = useState(false);
    const { layoutConfig } = /* useContext(LayoutContext) || */ {colorScheme: ""};

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        setError("");
       //if(layoutConfig) window.alert(layoutConfig?.colorScheme)
    }, [email, password, layoutConfig])

    const enter = async () => {
        const auth = getAuth();

        await signInWithEmailAndPassword(auth, email, password).then(() => { window.location.reload(); }).catch(err => {
            if (err?.code) {
                if (err.code === "auth/invalid-email") setError("Incorrect email");
                else if (err.code === "auth/wrong-password") setError("Password invalid");
                else setError(`There was an error with the login: ${err.code}`)
            }
            else setError(err?.message);
        }) 
    }
    const handleChangeEmail = (e) => { setEmail(e.target.value) }
    const handleChangePassword = (e) => { setPassword(e.target.value) }
    //const recuperar = () => { props.history.push("/recuperar_password") }

    const containerClassName = classNames('surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden', { 'p-input-filled': layoutConfig?.inputStyle === 'filled' });

    return (
        <div  className={containerClassName}>
            <div className="flex flex-column align-items-center justify-content-center">
                <div style={{ borderRadius: '56px', padding: '0.3rem', background: 'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)' }}>
                    <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: '53px' }}>
                        <div className="text-center mb-5">
                            <img src={`/images/logo-${layoutConfig?.colorScheme === 'light' ? 'dark' : 'white'}.svg`} alt="Image" height="50" className="mb-3" />
                            <div className="text-900 text-3xl font-medium mb-3">Sign in to continue</div>
                        </div>

                        <div>
                            <label htmlFor="email1" className="block text-900 text-xl font-medium mb-2">
                                Email
                            </label>
                            <InputText value={email} onChange={handleChangeEmail} inputid="email1" type="text" placeholder="Email address" className="w-full md:w-30rem mb-5" style={{ padding: '1rem' }} />

                            <label htmlFor="password1" className="block text-900 font-medium text-xl mb-2">
                                Password
                            </label>
                            <InputText value={password} onChange={handleChangePassword} inputid="password1" type="password" placeholder="Password" className="w-full md:w-30rem mb-5" style={{ padding: '1rem' }} />

                            <div className="flex align-items-center justify-content-between mb-5 gap-5">
                                {error && <Message severity="error" text={error} />}
                            </div>
                            <Button label="Sign In" className="w-full p-3 text-xl" onClick={enter}></Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;